import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init, deleteAccount } from './modules'
import Loading from 'components/Loading'
import {
  queryNotice,
  queryBillInfo,
  languageChange,
  queryConfigItem,
  checkIsLogin
} from 'store/siteConfig'

export default function(route) {
  const Main = Loadable({
    loader: () => import('./Main'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          utilityMainState: state.utilityMainState,
          siteConfig: state.siteConfig
        }),
        {
          init,
          queryNotice,
          deleteAccount,
          queryBillInfo,
          languageChange,
          queryConfigItem,
          checkIsLogin
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/main`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Main {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
